<template>
	<div v-loading.fullscreen.lock="$GVO.fullscreenLoading">
		<div v-if="bIsLoading">loading...</div>
		<div v-else>
			<div v-if="type=='edit'">
				<div class="bntGroup">
					<base-button @click="GoToEdit(false)" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div>
				<ReSearchCardStaffBigEdit :objStaff="masStaff[0]" />
				
			</div>
			<div v-else-if="type=='roles'">
				<div class="bntGroup">
					<base-button @click="GoToEditRoles(false)" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div>
				<ReSearchCardStaffBigRoles :objStaff="masStaff[0]" />
			</div>
			<div v-else-if="type=='settings'">
				<div class="bntGroup">
					<base-button @click="GoToEdit(false)" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
				</div>
				<ReSearchCardStaffBigSettings :objStaff="masStaff[0]" />
			</div>
			
			<div v-else> <!-- v-if="!bIsSettings && !bIsEdit && !bIsRoles" -->
				<div class="bntGroup">
					<base-button v-if="bCanEdit" @click="GoToEdit()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-pencil"></i></base-button>
				</div>
				<div class="bntGroup2">
					<el-tooltip content="Настройка ролей" placement="left">
						<base-button v-if="this.$GVO.my_profile.adm == 1" @click="GoToEditRoles()" type="info" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-pencil"></i></base-button>
					</el-tooltip>
				</div>
				<ReSearchCardStaffBig :objStaff="masStaff[0]" :arrDopContacts="this.arrDopContacts" />
				
				<!--card class="mt-3">
					<div class="col-sm-6 d-flex d-sm-block px-0 mb-3">
						<div
							class="btn-group btn-group-toggle"
							data-toggle="buttons">
							<label
								v-for="(option, index) in tabs.tabActions"
								:key="option.name"
								class="btn btn-sm btn-primary btn-simple"
								:class="{ active: tabs.activeIndex === index }"
								:id="index">
							<input
								type="radio"
								@click="initTabAction(index)"
								name="options"
								autocomplete="off"
								:checked="tabs.activeIndex === index"/>
							<span class="d-none d-sm-block">{{ option.name }}</span>
							<span class="d-block d-sm-none">
								<i :class="option.icon"></i>
							</span>
							</label>
						</div>
					</div>
					<h3>Мои клиенты</h3>					
				</card-->
			</div>
		</div>
	</div>
</template>
<script>

import ReSearchCardStaffBig from 'src/our_components/ReSearchCardStaffBig.vue';
import ReSearchCardStaffBigEdit from 'src/our_components/ReSearchCardStaffBigEdit.vue';
import ReSearchCardStaffBigSettings from 'src/our_components/ReSearchCardStaffBigSettings.vue';
import ReSearchCardStaffBigRoles from 'src/our_components/ReSearchCardStaffBigRoles.vue';
// import { Tooltip } from 'element-ui';

//import ReSidebarColor from 'src/our_components/ReSidebarColor.vue';
export default {
	name: 'staff-page',
	components: {
		ReSearchCardStaffBig,
		ReSearchCardStaffBigEdit,
		ReSearchCardStaffBigSettings,
		ReSearchCardStaffBigRoles,
		// Tooltip,
		//ReSidebarColor
	},
	data() {
		return {
			masStaff: [],
			bIsLoading: true,
			// bIsEdit: false,
			// bIsSettings: false,
			// bIsRoles: false,
			type:'',
			bCanEdit: this.canEdit(),
			arrDopContacts: [],
			/*tabs: {
				activeIndex: 0,
				tabActions: [{ name: 'Клиенты', icon: 'tim-icons icon-single-02' }, { name: 'Объекты', icon: 'tim-icons icon-square-pin' }, { name: 'Лента', icon: 'tim-icons icon-world' }],
			},*/
			
		};
	},
	methods: {
		canEdit(){
			this.$GVO.Api.staff.GET_RIGHT({flt:{code:this.$route.params.code}})
			.then((objApi) => {
				//console.log(objApi);
				if(objApi.success){
					if(objApi.right.edit) this.bCanEdit = objApi.right.edit;
				}
			})
			.catch(errorObjApi => console.error(errorObjApi));
			return false;
		},
		getStaff(){
			this.arrDopContacts = [];
			this.$GVO.ApiCall('GET',{obj:'staff' ,flt:{code:this.$route.params.code}})
			//this.$GVO.ApiCall(['GET','GET_CONTACTS'],[{obj:'staff' ,flt:{code:this.$route.params.code}},{obj:"staff",flt:{code:this.$route.params.code}}])
			.then((objApi) => { 
				this.bIsLoading = false;
				if(objApi.success === true){
					this.masStaff = objApi.data;
					this.masStaff[0].masDopContacts = [];
					// console.log(this.masStaff);
					/*
					this.$nextTick(() => {
						this.$GVO.scrollTop(); 
					});
					*/
				}
				this.$GVO.ApiCall('GET_CONTACTS',{obj:'staff' ,flt:{code:this.$route.params.code}})
				.then((objApi1) => { 
					
					if(objApi1.success === true){
						this.arrDopContacts = objApi1.data; //записываю в отдельный массив и передаю пропсом в ReSearchCardStaffBig, иначе создание-обунление выше this.masStaff[0].masDopContacts на стр 121 затирает данные в ReSearchCardStaffBig
						this.masStaff[0].masDopContacts = objApi1.data;
					}
				}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
				
			}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
		},
		initTabAction(index) {
			this.tabs.activeIndex = index;
		},
		GoToEdit(bGoEdit=true){
			//this.bIsEdit = bGo;
			if(bGoEdit){
				this.$router.push({path: '/data/staff/id/'+this.$route.params.code+'/edit'});
			}else{
				// this.$router.push({path: '/data/staff/id/'+this.$route.params.code});
				this.$router.back();
				
				// location.reload();
			}
		},
		GoToEditRoles(bIsRoles=true){
			//this.bIsEdit = bGo;
			if(bIsRoles){
				this.$router.push({path: '/data/staff/id/'+this.$route.params.code+'/roles'});
			}else{
				// this.$router.push({path: '/data/staff/id/'+this.$route.params.code});
				this.$router.back();
			}
		},
		checkPath(){
			const path = this.$route.path;
			if(path.indexOf('/'+this.$route.params.code+'/edit') != -1){
				this.type='edit';
				// this.bIsEdit = true;
				// this.bIsSettings = false;
				// this.bIsRoles = false;
			}else if(path.indexOf('/'+this.$route.params.code+'/settings') != -1){
				// this.bIsSettings = true;
				this.type='settings';
			}else if(path.indexOf('/'+this.$route.params.code+'/roles') != -1){
				// this.bIsRoles = true;
				this.type='roles';
			}else{
				// this.bIsEdit = false;
				// this.bIsSettings = false;
				// this.bIsRoles = false;
				this.type='';
			}
			this.getStaff();
		}
	},
	watch: {
		$route(to, from) {
			this.checkPath();
		}
	},
	created(){
		this.checkPath();
	},
	mounted() {

	},
};
</script>
<style scoped>
	.bntGroup{
		position: absolute;
		z-index: 1;
		right: 40px;
	}
	.bntGroup2{
		position: absolute;
		z-index: 1;
		right: 84px;
	}
</style>
